import { initializeApp } from "firebase/app";
import { getAnalytics, Analytics, logEvent } from "firebase/analytics";
import { getPerformance, FirebasePerformance, PerformanceTrace, trace } from "firebase/performance";
import { getMessaging, Messaging } from "firebase/messaging";
import { getLob } from "./services/authenticationService";
import { getFirebaseConfig, hasFirebaseConfig, FirebaseConfig } from "./config/firebaseConfigs";

function getConfigForCurrentLob(): FirebaseConfig {
  const lob = getLob();
  
  try {
    // Check if LOB-specific config exists
    if (hasFirebaseConfig(lob)) {
      return getFirebaseConfig(lob);
    } else {
      console.warn(`No Firebase config found for LOB: ${lob}, using default config`);
      return getFirebaseConfig('default');
    }
  } catch (error) {
    console.error('Error loading Firebase config:', error);
    // Fallback to default if there's any error
    console.warn('Falling back to default Firebase configuration');
    return getFirebaseConfig('default');
  }
}

// Get configuration for current LOB
const configToUse = getConfigForCurrentLob();

// Initialize Firebase
const app = initializeApp(configToUse);

// Initialize Analytics
const analytics: Analytics = getAnalytics(app);

// Initialize Performance Monitoring
const performance: FirebasePerformance = getPerformance(app);

// Initialize Cloud Messaging (only in browser environment)
let messaging: Messaging | null = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn('Firebase Cloud Messaging initialization failed:', error);
  }
}

const logLoadTrace = async (functionToTrace:()=>any,name:string)=>{
  const pageLoadTrace: PerformanceTrace = trace(performance, name);
  const t = new Date();
  pageLoadTrace.start();
  try{
    await functionToTrace();
  }catch(e){}
  pageLoadTrace.stop();
  console.log(`${name} log traced: ${(pageLoadTrace as any).durationUs / 1000} ms`);
}

const logAnalyticsEvent = (eventName:string, eventParams:any)=>{
  console.log(`${eventName} log triggered: ${JSON.stringify(eventParams)}`);
  logEvent(analytics, eventName, eventParams);
}

// Export for use in other files
export { app, analytics, performance, logLoadTrace, logAnalyticsEvent, messaging };
